import { Link } from 'react-router-dom';
import './order-placed-page.css';
import { Player } from '@lottiefiles/react-lottie-player';
import orderPlacedPage from './order-placed-page.json';
import HeaderOther from './header-other';

export default function OrderPlacedPage() {

    return (
        <div className='order-placed-page-container'>
            <HeaderOther />
            <div>
                <Player
                    autoplay
                    loop
                    src={orderPlacedPage}
                    style={{ height: '400px', width: '100%' }} // Adjust size as needed
                />
            </div>
            <div>
                <p className='order-placed-page-text'>Yahoo!</p>
                <p className='order-placed-page-text'>Your Order Has Been Successfully Placed!</p>
                <Link to='/orders' style={{textDecoration:'none'}} className='manage-orders-link'><p className='go-to-order-btn'>Track & Manage Orders</p></Link>
            </div>
        </div>
    );
}